import { useMemo } from 'react';

import { Account } from '@ndvr/portfolio-api';

import { useAssetClassExposureChart } from '@/cip/api/assetAllocation';

import { mapToExposureSlices } from '../assetClassExposure';

/**
 * Asset class exposure summed across every given account that has a broker account.
 * Errors are returned rather than thrown so an optimizer outage only affects the chart, not the page.
 */
export const useAssetClassExposure = (accounts: Account[]) => {
    const brokerAccountIds = useMemo(
        () => accounts.map((account) => account.brokerAccountId).filter((id): id is string => !!id),
        [accounts],
    );

    const {
        data: allocations,
        isLoading,
        isError,
    } = useAssetClassExposureChart(brokerAccountIds, {
        throwOnError: false,
    });

    const slices = useMemo(() => mapToExposureSlices(allocations ?? []), [allocations]);
    const totalExposure = slices.reduce((sum, slice) => sum + slice.exposure, 0);

    return { slices, totalExposure, isLoading, isError };
};
